// The surface every Shop card slot shares — the hydrated card, its skeleton,
// and the refresh reveal's "?" card (Figma "Tree slot" 1643:67099 and its
// unreveal state 1655:27140): half-white with the design's soft mint shadow
// on the card's 26px radius. One string, so the three can never drift apart
// and a card turning over keeps the same shell on both faces.
export const CARD_SURFACE_CLASS =
  'rounded-[26px] bg-white/50 shadow-[0_0_8px_0_rgba(187,227,220,0.25)]'
